import { getElementChild, getElements } from '../Utility/Dom'

class MediaCopyrightButton {
  private items: NodeListOf<HTMLElement>

  constructor() {
    this.items = getElements('copyright-button')
  }

  public init(): void {
    this.addEvents()
  }

  private addEvents(): void {
    this.items.forEach((button): void => {
      const text = getElementChild(button, 'copyright-text')
      const copyrightText = text?.textContent?.trim() || ''
      const baseLabel = button.getAttribute('aria-label') || 'Copyright'

      button.addEventListener('click', (): void => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true'
        button.setAttribute('aria-expanded', String(!isExpanded))

        if (!isExpanded) {
          button.setAttribute('aria-label', `${baseLabel}: ${copyrightText}`)
        } else {
          button.setAttribute('aria-label', baseLabel)
        }
      })
    })
  }
}

const mediaCopyrightButton = new MediaCopyrightButton()
mediaCopyrightButton.init()
